import { TData } from './model'

export const formDataCreate = (data: TData): FormData => {
  const formData = new FormData()

  Object.entries(data).forEach(([key, value]) => {
    if (value === undefined || value === null) {
      return
    }

    if (typeof value === 'number' || typeof value === 'boolean') {
      formData.append(key, value.toString())
    } else if (Array.isArray(value) && value.every(v => v instanceof File)) {
      value.forEach(file => formData.append(key, file))
    } else if (Array.isArray(value)) {
      value.forEach(item => {
        formData.append(`${key}[]`, item.toString())
      })
    } else if (typeof value === 'object' && !(value instanceof File)) {
      formData.append(key, JSON.stringify(value))
    } else {
      formData.append(key, value)
    }
  })

  return formData
}
